const ACTIONS = {
  ADD: 'Add',
  UPDATE: 'Update',
  DELETE: 'Delete',
  REMOVE: 'Remove',
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
  ALERT: 'Alert',
  SHARE: 'Share',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  COPY: 'COPY',
  ADDBOOKMARK: 'ADDBOOKMARK',
  REMOVEBOOKMARK: 'REMOVEBOOKMARK',
}

const VARIANT = {
  SUCCESS: 'Success',
  REMOVE: 'Remove',
  DANGER: 'Danger',
  INFO: 'Info',
  WARNING: 'Warning',
}

const MESSAGE = {
  ADD: 'added successfully!',
  LOGIN_SUCCESS: 'logged in successfully',
  UPDATE: 'updated successfully!',
  REMOVE: 'removed sucessfully!',
  DELETE: 'deleted sucessfully!',
  SUBMIT: 'submitted successfully!',
  SHARE: 'shared successfully!',
  ALERT: 'Something went wrong, Please try later!',
  CANCEL: 'cancelled successfully',
  COPY: 'to clipboard successfully',
  ADDBOOKMARK: 'to bookmarks successfully',
  REMOVEBOOKMARK: 'from bookmarks successfully',
}

export const toastState = (action, payload) => {
  switch (action) {
    case ACTIONS.ADD:
      return {
        message: `${payload.type} ${MESSAGE.ADD}`,
        variant: VARIANT.SUCCESS,
      }
    case ACTIONS.REMOVEBOOKMARK:
      return {
        message: `${payload.type} ${MESSAGE.REMOVEBOOKMARK}`,
        variant: VARIANT.REMOVE,
      }
    case ACTIONS.ADDBOOKMARK:
      return {
        message: `${payload.type} ${MESSAGE.ADDBOOKMARK}`,
        variant: VARIANT.SUCCESS,
      }
    case ACTIONS.COPY:
      return {
        message: `${payload.type} ${MESSAGE.COPY}`,
        variant: VARIANT.SUCCESS,
      }
    case ACTIONS.DELETE:
      return {
        message: `${payload.type} ${MESSAGE.DELETE}`,
        variant: VARIANT.DANGER,
      }
    case ACTIONS.REMOVE:
      return {
        message: `${payload.type} ${MESSAGE.REMOVE}`,
        variant: VARIANT.REMOVE,
      }
    case ACTIONS.CANCEL:
      return {
        message: `${payload.type} ${MESSAGE.CANCEL}`,
        variant: VARIANT.REMOVE,
      }
    case ACTIONS.UPDATE:
      return {
        message: `${payload.type} ${MESSAGE.UPDATE}`,
        variant: VARIANT.SUCCESS,
      }
    case ACTIONS.SUBMIT:
      return {
        message: `${payload.type} ${MESSAGE.SUBMIT}`,
        variant: VARIANT.SUCCESS,
      }
    case ACTIONS.SHARE:
      return {
        message: `${payload.type} ${MESSAGE.SHARE}`,
        variant: VARIANT.SUCCESS,
      }
    case ACTIONS.LOGIN_SUCCESS:
      return {
        message: `${payload.type} ${MESSAGE.LOGIN_SUCCESS}`,
        variant: VARIANT.SUCCESS,
      }
    case ACTIONS.ALERT:
      return { message: MESSAGE.ALERT, variant: VARIANT.WARNING }
    default:
      return
  }
}
